export default __webpack_public_path__ + "static/media/offer-vertical-chocolate@2x.da5d3a0f.png";